var _path, _path2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmployment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,23.25H42.70605v-.13135A4.36,4.36,0,0,0,44.4082,19.648a4.40283,4.40283,0,1,0-7.11328,3.46875V23.25H10a.7502.7502,0,0,0-.75.75V60a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V24A.7502.7502,0,0,0,70,23.25ZM37.10254,19.648a2.90283,2.90283,0,0,1,5.80566,0,2.8708,2.8708,0,0,1-1.35156,2.44531.75163.75163,0,0,0-.35059.63526V27.25H38.79492V22.72852a.7506.7506,0,0,0-.34863-.63331A2.88453,2.88453,0,0,1,37.10254,19.648ZM69.25,59.25H10.75V24.75H37.29492V28a.7502.7502,0,0,0,.75.75h3.91113a.75019.75019,0,0,0,.75-.75V24.75H69.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25,33.25A9.75,9.75,0,1,0,34.75,43,9.76128,9.76128,0,0,0,25,33.25Zm0,18a8.18957,8.18957,0,0,1-4.26709-1.20264,4.22432,4.22432,0,0,1,8.41064.07471A8.18619,8.18619,0,0,1,25,51.25Zm-2.64746-9.07324a2.582,2.582,0,1,1,2.582,2.582A2.58483,2.58483,0,0,1,22.35254,42.17676Zm8.15527,6.94775a5.7626,5.7626,0,0,0-3.042-3.77051,4.08211,4.08211,0,1,0-5.0625,0,5.7639,5.7639,0,0,0-3.01709,3.67432,8.25029,8.25029,0,1,1,11.12158.09619Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 35.25,
    width: 24,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 42.25,
    width: 24,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 49.25,
    width: 24,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmployment);
export default __webpack_public_path__ + "static/media/icon_employment.32bb9bec21f66b8ea016eecd608f9752.svg";
export { ForwardRef as ReactComponent };